export const FORM_TYPES = {
  EDITROW: "EDITROW",
  DETECTCHANGES: "DETECTCHANGES",
  UPDATEDATE: "UPDATEDATE",
  CLEAN_FORM: "CLEAN_FORM",
};
